import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Fab from '@material-ui/core/Fab';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Zoom from '@material-ui/core/Zoom';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { theme } from './static/theme';
import Button from '@material-ui/core/Button';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import './static/style.css';

import ReactTypingEffect from 'react-typing-effect';
import Slide from '@material-ui/core/Slide';
import Tooltip from '@material-ui/core/Tooltip';
import Popover from '@material-ui/core/Popover';
import GitHubIcon from '@material-ui/icons/GitHub';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MenuIcon from '@material-ui/icons/Menu';
import Portfolio from './components/Portfolio';
import Skill from './components/Skill';
import Chatbot from './components/Chatbot/App15';
import Blog from './components/Blog';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Language from './components/Language';
import Certifications from './components/Certifications';
import Hamburger from './components/Hamburger';
import cat from './static/img/cat.png';
import { useMediaQuery } from 'react-responsive';
import {enFlag} from './static/img/en.png'
import {jaFlag} from './static/img/ja.png'
const useStyles = makeStyles((theme) => ({
	root: {
		position: 'fixed',
		bottom: theme.spacing(2),
		right: theme.spacing(2)
	}
}));

const ScrollTop = (props) => {
	const { children, window } = props;
	const classes = useStyles();
	const trigger = useScrollTrigger({
		target: window ? window() : undefined,
		disableHysteresis: true,
		threshold: 100
	});

	const clickScrollTop = (e) => {
		const anchor = (e.target.ownerDocument || document).querySelector('#back-to-top-anchor');
		if (anchor) {
			anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
	};

	return (
		<Zoom in={trigger}>
			<div onClick={(e) => clickScrollTop(e)} role="presentation" className={classes.root}>
				{children}
			</div>
		</Zoom>
	);
};

ScrollTop.propTypes = {
	children: PropTypes.element.isRequired,
	window: PropTypes.func
};

const HideOnScroll = (props) => {
	const { children, window } = props;
	const trigger = useScrollTrigger({ target: window ? window() : undefined });

	return (
		<Slide appear={false} direction="down" in={!trigger}>
			{children}
		</Slide>
	);
};

HideOnScroll.propTypes = {
	children: PropTypes.element.isRequired,
	window: PropTypes.func
};

const App = (props) => {
	const [ chatOpen, setChatOpen ] = useState(false);
	const [ language, setLanguage ] = useState('English');
	const [catText, setCatText] = useState("")
	const [typingText, setTypingText] = useState([])
	const menusEn = [{name:'Home', link:'about'}, {name:'SKILL', link:'skill'}, {name:'PORTFOLIO', link:'portfolio'}, {name:'BLOG', link:'blog'}, {name:'PROJECTS', link:'projects'}, {name:'OTHERS', link:'others'}, {name:'CONTACT', link:'contact' }];
	const menusJa = [{name:'ホーム', link:'about'}, {name:'スキル', link:'skill'}, {name:'ポートフォリオ', link:'portfolio'}, {name:'ブログ', link:'blog'}, {name:'プロジェクト', link:'projects'}, {name:'その他', link:'others'}, {name:'お問い合わせ', link:'contact' }]
	
	const [menus, setMenus] = useState(menusEn)
	useEffect(() => {
		switch (language) {
			case 'English':
				setCatText("Let's chat! Click meow!")
				setTypingText([ "Hello! I'm Anna, Web developer!", "If you have any questions, feel free to message me!" ])
				setMenus(menusEn)
			  	break;
			case '日本語':
				setCatText("クリックしてチャットボットを開く！");
				setTypingText(['当ウェブサイトに訪問下さり、ありがとうございます！', 'ご質問などあればお気軽にお問い合わせください！'])
				setMenus(menusJa)
				break;
			default:
				setCatText("Let's chat! Click meow!")
		  }
	}, [language])
	const chatCat = (
		<Tooltip open={true} title={catText} placement="top" arrow>
			<img className="chatOpenBtn fuwafuwa" src={cat} onClick={() => setChatOpen(true)} />
		</Tooltip>
	);

	const [ anchorLangSetEl, setAnchorLangSetEl ] = useState(null);

	const langSetOpen = Boolean(anchorLangSetEl);
	const handleLanguageChange = (language) => {
		setLanguage(language);
		setAnchorLangSetEl(null);
	};

	const languages = [ 'English', '日本語' ];
	const sections = [
		{ id: 'skill', content: <Skill language={language} /> },
		{ id: 'portfolio', content: <Portfolio language={language} /> },
		{ id: 'blog', content: <Blog language={language} /> },
		{ id: 'projects', content: <Projects language={language} /> },
		{
			id: 'others',
			content: (
				<Fragment>
					<Language language={language} />
					<Certifications language={language} />
				</Fragment>
			)
		},
		{ id: 'contact', content: <Contact language={language} /> }
	];
	const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
	return (
		<Fragment>
			<MuiThemeProvider theme={theme}>
				<CssBaseline />
				<HideOnScroll {...props}>
					<AppBar style={{ width: '100%', float: 'left' }}>
						<Toolbar className="d-flex justify-content-between">
							<Typography variant="h2" className="logoLetter">
								A.N.
							</Typography>
							<div className="d-flex justify-content-between">
							
								<Button
									color="secondary"
									onClick={(e) => setAnchorLangSetEl(e.currentTarget)}
									className={isTabletOrMobile ? 'font-medium':'font-large'}
								>
									{language}
									<ExpandMoreIcon className="font-xlarge" />
								</Button>
								
								<Popover
									open={langSetOpen}
									anchorEl={anchorLangSetEl}
									onClose={() => setAnchorLangSetEl(null)}
									anchorOrigin={{
										vertical: 'top',
										horizontal: 'left'
									}}
									transformOrigin={{
										vertical: 'top',
										horizontal: 'left'
									}}
								>
									{languages.map((language, i) => (
										<MenuItem className="font-large" onClick={() => handleLanguageChange(language)} key={i}>
											{language}
										</MenuItem>
									))}
								</Popover>
								<IconButton target="_blank" href="https://github.com/anzunba">
									<GitHubIcon className="font-xlarge" color="secondary" />
								</IconButton>
								{isTabletOrMobile?<Hamburger menus={menus} /> : menus.map((menu, i) => (
									<Button color="secondary" key={i}>
										<AnchorLink color="secondary" href={`#${menu.link}`}>
											<h4>{menu.name}</h4>
										</AnchorLink>
									</Button>
								))}
							</div>
						</Toolbar>
					</AppBar>
				</HideOnScroll>
				<Toolbar id="back-to-top-anchor" />
				<section id="about" className="vh-100 aboutSection text-center">
					<h1>
						<ReactTypingEffect
							text={typingText}
							speed={120}
							eraseDelay={1500}
							typingDelay={100}
						/>
					</h1>
				</section>
				{sections.map((section, i) => (
					<section id={section.id} className={`${isTabletOrMobile || section.id === 'projects' || section.id === 'others' || section.id === 'portfolio' ? null: "vh-100"} pt-3 px-5`} key={i}>
						{section.content}
					</section>
				))}
				<ScrollTop {...props}>
					<Fab color="secondary" size="small" aria-label="scroll back to top">
						<KeyboardArrowUpIcon />
					</Fab>
				</ScrollTop>
				{chatOpen ? (
					<div className="fixedDiv">
						<Chatbot className="chatDiv" setChatOpen={setChatOpen} />
					</div>
				) : (
					chatCat
				)}
				<div className="w-100 bg-dark text-center pt-2 font-large" style={{ height: '50px', color: 'white' }}>
					© 2020 A.N.
				</div>
			</MuiThemeProvider>
		</Fragment>
	);
};
export default App;
